import gql from 'graphql-tag';

export default gql`
  mutation DeleteManifestHistoryRouteBulk($input: DeleteManifestHistoryRouteBulkInput!) {
    deleteManifestHistoryRouteBulk(input: $input) {
      deleted
    }
  }
`;
